import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { IconButton, TooltipHost } from '@fluentui/react';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { SupportIcon } from './support-icon';

const getStyles = () => ({
  button: {
    height: '48px',
    width: '48px',
    maxWidth: '48px',
  },
});

export const SupportButton = ({
  onClick,
}) => {
  const classes = useDefaultStyles(getStyles);
  const i18n = useContext(I18nContext);

  return (
    <TooltipHost content={i18n.getString(_TL_('Start live chat'))} calloutProps={{ doNotLayer: true }}>
      <IconButton
        className={classNames(classes.button, 'support-button', 'SupportTopic')}
        aria-label={i18n.getString(_TL_('Start live chat'))}
        id="support-button"
        onClick={onClick}
      >
        <SupportIcon className="SupportTopic" />
      </IconButton>
    </TooltipHost>
  );
};

SupportButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};
